import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ybpedjetwhdypinttzom.supabase.co';
const supabaseAnonKey = 'sb_publishable_SYb06cxPfn4PmXK7xOtAtQ_9mlrDBrN';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);